import React from 'react';

import Network5xxError from './ErrorComponents/Network5xxError';
import { ErrorContainer } from './styles.compiled';

export const FullPageError = (props: { testId?: string }): React.JSX.Element => (
	<ErrorContainer isFullPage data-testid={props.testId}>
		<Network5xxError />
	</ErrorContainer>
);
